import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";

const SearchMandub = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            MM_note,
            AddProChange,
            MM_getParaDataBySearchMoney,
            MM_qarzeKonDolar,
            MM_qarzeKonID,
            MM_getWakilDataBySearchMoney,
            MM_zhmara,
            MM_joredraw,
            MM_isChecked,
            MM_getIsChecked,
            MM_del_dis,
            Ap_kasakan,
            MM_nawebarez,
            MM_peshandaniQarzyPeshw,
            M_nrx_Remembe,
            M_Kren_Remembe,
            Change_Dinar_to_R,
            Change_R_Dolar,
            MM_qarzeKonR,
            M_nrx_Remembe_2,
            M_nrx_dolar_2,
            MM_lastPayment,
            ok_2, PD_peshandaniQarzyPeshw_kon, MM_search_wasl,
            MM_Amount_Dolar,
            MM_High_Dolar,
            MM_Low_Dolar,
            MM_Amount_Dinar,
            MM_Remebi_Price,
            MM_DolartoRemembi_WithOut_Balance,
            MM_DolartoDinare,
            MM_DinartoRemembi_Without_Balance,
          } = value;
          const wakilakn = Ap_kasakan.filter((user) => {
            return user.Name.trim().startsWith(MM_nawebarez);
          }).map((item, index) => {
            return (
              <option className="fk" key={index}>
                {item.Name}
              </option>
            );
          });
          return (
            <>
              <div
                className="card card-primary text-warning font-weight-bold"
                style={{ backgroundColor: "#2C3539" }}
              >
                <div
                  className="card-header border-bottom border-warning"
                  style={{ backgroundColor: "#2C3539" }}
                >
                  <h3 className="card-title tc "> گەران بە دوای </h3>
                </div>

                <form>
                  <div className="card-body text-right">
                    <div className="form-group">
                      <label className="font-weight-bold f4">:پسوولە</label>
                      <input
                        onKeyPress={(event) =>
                          event.key == "Enter"
                            ? MM_getParaDataBySearchMoney(event)
                            : null
                        }
                        type="text"
                        onChange={AddProChange}
                        value={MM_zhmara}
                        name="MM_zhmara"
                        className="form-control text-right font-weight-bold"
                        placeholder="...گەڕان"
                      />
                    </div>
                    <div className="form-group">
                      <label className="font-weight-bold f4">: وەکیل </label>
                      <select
                        className="form-control text-right font-weight-bold selectpicker pull-right "
                        onChange={AddProChange}
                        name="MM_nawebarez"
                        value={MM_nawebarez}
                        onKeyPress={(event) =>
                          event.key == "Enter"
                            ? MM_getWakilDataBySearchMoney(event)
                            : null
                        }
                      >
                        <option className="ml5">Search</option>
                        {wakilakn}
                      </select>
                    </div>
                    <div className="form-group">

                      <label className="font-weight-bold f4">:کۆتا پارەدانی وەسڵ </label>
                      <NumberFormat
                        value={(MM_lastPayment)}
                        displayType={"text"}
                        className="form-control text-right font-weight-bold p-2"
                        thousandSeparator={true}
                        prefix={MM_lastPayment && MM_lastPayment.split(" ")[1]}
                      />

                    </div>
                    <div className="form-group">
                      <label className="font-weight-bold f4">:تێبینی </label>
                      <input
                        type="text"
                        onChange={AddProChange}
                        value={MM_note}
                        name="MM_note"
                        className="form-control text-right font-weight-bold"
                        disabled={MM_del_dis ? true : null}
                        placeholder="...تێبینی"
                      />
                    </div>
                  </div>
                  {/* remembe */}
                  {/* <div className="row text-right ">
                    <div className="col-2 mt4">
                      <button
                        className="btn btn-success mt1"
                        onClick={Change_R_Dolar}
                        disabled={MM_del_dis ? true : null}
                      >
                        ok
                      </button>
                    </div>
                    <div className="col-5">
                      <label className="font-weight-bold text-warning f4">
                        : RRR نرخی
                      </label>
                      <NumberFormat
                        displayType="input"
                        thousandSeparator={true}
                        name="M_nrx_Remembe"
                        onChange={AddProChange}
                        disabled={MM_del_dis == true ? true : null}
                        value={M_nrx_Remembe == 0 ? "" : M_nrx_Remembe}
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                    <div className="col-5">
                      <label className="font-weight-bold text-warning f4">
                        : RRR کڕینی
                      </label>
                      <NumberFormat
                        displayType="input"
                        thousandSeparator={true}
                        name="M_Kren_Remembe"
                        onChange={AddProChange}
                        disabled={MM_del_dis == true ? true : null}
                        value={M_Kren_Remembe == 0 ? "" : M_Kren_Remembe}
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                  </div> */}
                  <hr />
                  {/* <div className="row text-right ">

                    <div className="col-4">
                      <label className="font-weight-bold text-warning ">
                        : IQDبڕی پارە
                      </label>
                      <NumberFormat
                        displayType="input"
                        thousandSeparator={true}
                        name="MM_Amount_Dinar"
                        onChange={AddProChange}
                        disabled={MM_del_dis == true ? true : null}
                        value={MM_Amount_Dinar}
                        className="form-control text-right text-white font-weight-bold bg-danger"
                      />
                    </div>
                    <div className="col-4">
                      <label className="font-weight-bold text-warning ">
                        : دۆلار گران
                      </label>
                      <NumberFormat
                        displayType="input"
                        thousandSeparator={true}
                        name="MM_High_Dolar"
                        onChange={AddProChange}
                        disabled={MM_del_dis == true ? true : null}
                        value={MM_High_Dolar}
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                    <div className="col-4">
                      <label className="font-weight-bold text-warning ">
                        :$بڕی پارە
                      </label>
                      <NumberFormat
                        displayType="input"
                        thousandSeparator={true}
                        name="MM_Amount_Dolar"
                        onChange={AddProChange}
                        disabled={MM_del_dis == true ? true : null}
                        value={MM_Amount_Dolar}
                        className="form-control text-right text-white font-weight-bold bg-success"
                      />
                    </div>

                    <div className="col-4 row">
                      <div className="col-4 mt4">
                        <button
                          className="btn btn-warning mt1"
                          onClick={MM_DinartoRemembi_Without_Balance}
                          disabled={MM_del_dis == true ? true : null}
                        >
                          ok
                        </button>
                      </div>
                      <div className="col-4 mt4">
                        <button
                          className="btn btn-success mt1"
                          onClick={MM_DolartoRemembi_WithOut_Balance}
                          disabled={MM_del_dis == true ? true : null}
                        >
                          $
                        </button>
                      </div>
                      <div className="col-4 mt4">
                        <button
                          className="btn btn-danger mt1"
                          onClick={MM_DolartoDinare}
                          disabled={MM_del_dis == true ? true : null}
                        >
                          IQD
                        </button>
                      </div>
                    </div>
                    <div className="col-4">
                      <label className="font-weight-bold text-warning ">
                        : RRR نرخی
                      </label>
                      <NumberFormat
                        displayType="input"
                        thousandSeparator={true}
                        name="MM_Remebi_Price"
                        onChange={AddProChange}
                        disabled={MM_del_dis == true ? true : null}
                        value={MM_Remebi_Price}
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                    <div className="col-4">
                      <label className="font-weight-bold text-warning ">
                        : دۆلار هەرزان
                      </label>
                      <NumberFormat
                        displayType="input"
                        thousandSeparator={true}
                        name="MM_Low_Dolar"
                        onChange={AddProChange}
                        disabled={MM_del_dis == true ? true : null}
                        value={MM_Low_Dolar}
                        className="form-control text-right font-weight-bold"
                      />
                    </div>


                  </div> */}
                  <br />
                  <div className="col-12 text-right ml5">
                    <table id="non">
                      <thead>
                        <tr>
                          <th className="text-right pb-2 text-warning f4">
                            <input
                              onChange={MM_getIsChecked}
                              checked={MM_isChecked == true ? true : false}
                              value={MM_isChecked}
                              type="checkbox"
                              className="mr3"
                            />
                            :پیشاندانی ڕەسیدی پێشوو
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {MM_isChecked == true ? (
                          <>
                            <tr>
                              <td className="text-right">
                                <label className="font-weight-bold text-warning f4">
                                  : ڕەسیدی کۆن
                                </label>
                                <NumberFormat
                                  value={
                                    MM_joredraw == "دۆلار"
                                      ? MM_qarzeKonDolar
                                      : MM_joredraw == "دینار"
                                        ? MM_qarzeKonID
                                        : MM_qarzeKonR
                                  }
                                  displayType={"text"}
                                  className="form-control text-right font-weight-bold"
                                  thousandSeparator={true}
                                  prefix={
                                    MM_joredraw == null
                                      ? ""
                                      : MM_joredraw == "دۆلار"
                                      ? "$"
                                      : MM_joredraw == "دینار"
                                      ? "ID"
                                      : "R"
                                  }
                                />
                              </td>
                            </tr>
                            <tr>
                              <td className="text-right ">
                                <label className="font-weight-bold text-warning f4">
                                  :ڕەسیدی ئێستا
                                </label>
                                <NumberFormat
                                  value={PD_peshandaniQarzyPeshw_kon(MM_joredraw)}
                                  displayType={"text"}
                                  className="form-control text-right font-weight-bold"
                                  thousandSeparator={true}
                                  prefix={
                                    MM_joredraw == null
                                      ? ""
                                      : MM_joredraw == "دۆلار"
                                      ? "$"
                                      : MM_joredraw == "دینار"
                                      ? "ID"
                                      : "R"
                                  }
                                />
                              </td>
                            </tr>
                          </>
                        ) : null}
                      </tbody>
                    </table>
                  </div>

                  <div
                    className="card-footer"
                    style={{ backgroundColor: "#2C3539" }}
                  ></div>
                </form>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default SearchMandub;
